import React from "react";
import CustomTable from "../customTable";
import { ResultsPerListAndCampaignsColumns } from "./columns/ResultsPerListAndCampaignsColumns";
import Comments from "../comments";

// Define columns based on ResultsPerListAndCampaignsColumns
const ResultsPerSegmentOfListColumns = [
  ...ResultsPerListAndCampaignsColumns.slice(0, 3),
  { header: "Segment", accessor: "segment" },
  ...ResultsPerListAndCampaignsColumns.slice(3),
];

const ResultsPerSegmentOfList = ({ processedData, loading }) => {

  return (
    <div className="d-flex flex-column gap-2">
      <CustomTable
        columns={ResultsPerSegmentOfListColumns}
        data={processedData?.results_per_segment_of_list?.data || []}
        totalAggregatedData={processedData?.results_per_segment_of_list?.totals || {}}
        loading={loading}
        storageKey={"resultspersegmentoflist"}
      />
      <Comments tab_name="Results per segment of list" />
    </div>
  );
};

export default ResultsPerSegmentOfList;
